import { EventStatus } from '../../componentsV2/lvc-card/lvc-event-status'
import { Attrs, MinzeElement } from 'minze'
import { renderDateElement, renderTicketButton } from '../../componentsV2/lvc-card/utils'
import { Locale } from '../../modules/locale'
import { decodeSlides, LvcPrimarySliderItem } from '../../modules/sliderUtils'
import { getCardPlaceholder } from '../../modules/utils'

export interface LvcGridLayout {
  dataComponentLocation: string
}
export class LvcGridLayout extends MinzeElement {
  attrs: Attrs = [
    ['data', ''],
    ['showcase-mode', 'true'],
    ['grid-template', '1fr 1fr 1fr 1fr'],
    ['tablet-grid-template', '1fr 1fr'],
    ['mobile-grid-template', '1fr'],
    'data-component-location',
  ]
  static observedAttributes = ['data']
  // TODO: Create a separate event-showcase-card component.
  // TODO: All mapping should be handled outside component level for standardization. Helper function
  // TODO: Both event card will take the same data structure.
  html = () => {
    return /*html*/ `
      ${decodeSlides(this.data as string)
        .map((item: LvcPrimarySliderItem, index) => {
          return /*html*/ `
            <lvc-card href="${item?.urlConstruct?.[Locale.language]}" is-showcase="${
              this.showcaseMode && (index === 0 || index === 9) ? 'true' : 'false'
            }">
              ${
                item.status
                  ? /*html*/ `
                <lvc-event-status
                  slot="status"
                  status="${item.status}"
                ></lvc-event-status>
              `
                  : ''
              }
              <lvc-image slot="image" src="${item?.cardImage || getCardPlaceholder(item?.schema as string)}" data-image-placeholder="${getCardPlaceholder(item?.schema as string)}" data-cf-image-width="${this.showcaseMode && (index === 0 || index === 9) ? 1920 : 800}"></lvc-image>
              ${
                item.festivals
                  ? /*html*/ `
                <img
                  src="https://cloud.squidex.io/api/assets/lvc-dev/52d936d4-b4dd-41e2-a763-e6c39cccc98f/lavitrine-ico-ne-festival-1-.png"
                  slot="festival-icon"
                />
              `
                  : ''
              }
              ${
                item.status !== EventStatus.Cancelled
                  ? `
              <lvc-favorite-icon-button
                slot="favorite"
                data-id="${item?.id || ''}"
                data-type="${item?.schema || ''}" 
                data-gtm-name="${item?.name?.[Locale.language] || ''}"
                data-gtm-brand="${item?.artist?.[Locale.language] || ''}"
                data-gtm-category="${Array.isArray(item?.uiAdditionalTypes) ? item.uiAdditionalTypes.map(type => type.code).join(', ') : ''}"
                data-gtm-category2="${item?.location?.[Locale.language] || ''}"
                data-gtm-category3="${item?.formattedDateTime || ''}"
                data-gtm-category4="${item?.isAccessibleForFree ? 'Gratuit' : 'Billet'}"                >
              </lvc-favorite-icon-button>
              `
                  : ''
              }
              ${item?.festivals ? `<lvc-event-festival-badge slot="festival" label="${item?.festivals?.[0]?.nameFr}"></lvc-event-festival-badge>` : ''}
              <div slot="title">${item?.name?.[Locale.language]}</div>
              ${renderDateElement(item, item?.status, item?.previousStartDate)}
              ${
                item?.location?.[Locale.language]
                  ? `<lvc-event-location
                  slot="location"
                  text="${[item?.location?.[Locale.language], item?.city?.[Locale.language]].filter(Boolean).join(', ')}"
                ></lvc-event-location>`
                  : ''
              }
              ${renderTicketButton(item, this.dataComponentLocation)}
              <lvc-tags slot="tag" data-discipline-tags="${encodeURIComponent(JSON.stringify(item.uiAdditionalTypes))}"></lvc-tags>
            </lvc-card>
          `
        })
        .join('')}
    `
  }
  css = () => /*css*/ `
    :host {
      display: grid;
      grid-template-columns: ${this.mobileGridTemplate};
      column-gap: 20px;
      row-gap: 60px;
      padding-top: 40px;
    }

    @media only screen and (min-width: 768px) {
      :host {
        grid-template-columns: ${this.tabletGridTemplate};
      }
    }

    @media only screen and (min-width: 1200px) {
      :host {
        grid-template-columns: ${this.gridTemplate};
      }
    }
  `
}
